import React from 'react';
import { describeOAuthError } from '../../lib/OAuthErrors';

function OAuthErrorNotice({ error, fallback }) {
	let details = describeOAuthError(error, fallback);
	return <div className="oauth-error-notice" role="alert">
		<p className="validation-text">{details.message}</p>
		<p className="oauth-error-reference"><strong>Error reference:</strong> <code>{details.reference}</code>{details.status ? ` · HTTP ${details.status}` : ''}</p>
		<p className="muted">{details.hasServerReference
			? 'Quote this reference to Blackout support so we can locate the failed request.'
			: 'No response reached Blackout, so this is a browser-side reference. Quote it together with the time and your network details.'}</p>
	</div>;
}

export default OAuthErrorNotice;
